import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateGroupComponent } from './create-group/create-group.component';
import { GroupListComponent } from './group-list/group-list.component';
import { ManageGroupComponent } from './manage-group/manage-group.component';
import { AuthGuard } from '../shared/auth-guard';
const routes: Routes = [
    { path: 'managegroup', component: GroupListComponent, canActivate: [AuthGuard] },
    { path: 'creategroup', component: CreateGroupComponent, canActivate: [AuthGuard] },
    { path: 'group', component: ManageGroupComponent, canActivate: [AuthGuard] }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class GroupRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/group/group-routing.module.ts